import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { Inertia } from '@inertiajs/inertia';
import { InertiaLink, usePage } from '@inertiajs/inertia-react';
import AdminLayout from '../../../../Shared/AdminLayout';
import ProfileCard from '../../../../Shared/ProfileCard';
import DataCard from '../../../../Shared/DataCard';
import DataContainer from '../../../../Shared/DataContainer';
import Icon from '../../../../Shared/Icon';
import classNames from 'classnames';
import TextInput from '../../../../Shared/TextInput';
import FileInput from '../../../../Shared/FileInput';
import SelectInput from '../../../../Shared/SelectInput';
import LoadingButton from '../../../../Shared/LoadingButton';
import { toFormData } from '../../../../utils';

function Edit() {
     const { auth, errors, data } = usePage().props;
     const [sending, setSending] = useState(false);
     const [values, setValues] = useState({
          category: data.category.id,
          name: data.subcategory.name || '',
          type: data.subcategory.type || 0,
          image: null,
          description: data.subcategory.description || '',
          order: data.subcategory.order || 0,
          status: data.subcategory.status,
          caption: data.subcategory.caption
     });

     const iconClasses = classNames('w-4 h-4 mr-2', {
          'text-white fill-current': false,
          'text-gray-500 hover:text-white fill-current': true
     });

     function handleChange(e) {
          const key = e.target.name;
          const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
          let caption = values.caption;
          if(e.target.type === 'checkbox'){
               caption = (value)?'Active': 'Inactive';
          }
          setValues(values => ({
               ...values,
               [key]: value,
               caption: caption
          }));
     }

     function handleFileChange(file, path) {
          setValues(values => ({
               ...values,
               image: file
          }));
     }

     function handleSubmit(e) {
          e.preventDefault();
          setSending(true);
          const formData = toFormData(values, 'POST');
          Inertia.post(route('subcategory.update', [data.category.id, data.subcategory.id]), formData).then(() => {
               setSending(false);
          });
     }

     return (
          <React.Fragment key="permission-c">
               <ProfileCard>
                    <div className="md:col-span-1">
                         <div className="px-4 sm:px-0">
                              <h3 className="text-lg font-medium text-gray-900">Edit Sub-Category</h3>
                              <p className="mt-1 text-sm text-gray-600">
                                   Use the form to edit information relative to a subcategory <b>{data.subcategory.name}</b> of the category <b>{data.category.name}</b>
                              </p>
                         </div>
                    </div>
                    <DataCard>
                         <form onSubmit={handleSubmit}>
                              <div className="px-4 py-5 sm:p-6">
                                   <div className="grid grid-cols-3 gap-3">
                                        <div className="col-span-12 text-right">
                                             <InertiaLink href={route('subcategory.index', data.category.id)} className="inline-flex items-center p-2 text-sm text-gray-500 bg-transparent border border-gray-500 rounded focus:outline-none hover:bg-gray-600 hover:text-gray-100">
                                                  <Icon name="back" className={iconClasses} />
                                                  Back
                                             </InertiaLink>
                                        </div>
                                        <div className="col-span-6 sm:col-span-4">
                                             <label className="block text-sm font-medium text-gray-700" htmlFor="photo">
                                                  <span>Image</span>
                                             </label>
                                             <div className="mt-2">
                                                  <img src={`https://ui-avatars.com/api/?name=Produit&amp;color=7F9CF5&amp;background=EBF4FF`} className="w-20 h-20 rounded-full" />
                                             </div>
                                             <FileInput
                                                  className="w-full lg:w-1/2"
                                                  label="Select Picture"
                                                  name="image"
                                                  accept="image/.jpg,.jpeg,.png"
                                                  errors={errors.image}
                                                  value={values.image}
                                                  onChange={handleFileChange}
                                              />
                                             <TextInput
                                                   className="block w-full mt-4 rounded-md shadow-sm form-input"
                                                   label="Name"
                                                   name="name"
                                                   type="text"
                                                   disable={false}
                                                   readonly={false}
                                                   errors={errors.name}
                                                   value={values.name}
                                                   onChange={handleChange}
                                              />
                                              <TextInput
                                                   className="block w-full mt-4 rounded-md shadow-sm form-input"
                                                   label="Description"
                                                   name="description"
                                                   type="text"
                                                   disable={false}
                                                   readonly={false}
                                                   errors={errors.description}
                                                   value={values.description}
                                                   onChange={handleChange}
                                              />
                                             <TextInput
                                                  className="block w-full mt-4 rounded-md shadow-sm form-input"
                                                  label="Order"
                                                  name="order"
                                                  type="text"
                                                  disable={false}
                                                  readonly={false}
                                                  errors={errors.order}
                                                  value={values.order}
                                                  onChange={handleChange}
                                             />
                                              <label className="block w-full mt-4 rounded-md shadow-sm form-input" htmlFor="perms">
                                                   <input name="status" className="form-checkbox" type="checkbox" value={values.status} checked={values.status} onChange={handleChange}/>
                                                   <span className="ml-2 text-sm text-gray-800">{values.caption}</span>
                                              </label>
                                        </div>
                                   </div>
                              </div>
                              <div className="flex items-center justify-end px-4 py-3 text-right bg-gray-100 rounded-b sm:px-6">
                                   <LoadingButton type="submit" loading={sending} className="inline-flex items-center px-4 py-2 ml-4 text-xs font-semibold tracking-widest text-white uppercase transition duration-150 ease-in-out bg-gray-800 border border-transparent rounded-md hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:shadow-outline-gray disabled:opacity-25">
                                        Save
                                   </LoadingButton>
                              </div>
                         </form>
                    </DataCard>
               </ProfileCard>
          </React.Fragment>
     );
}

// Persisten layout
// Docs: https://inertiajs.com/pages#persistent-layouts
Edit.layout = page => <AdminLayout children={page} header={'Edit Category'} />;

export default Edit;
